import api from '../api';

/**
 * Fetches orders for a given store within a specified date range.
 *
 * @param {string} storeCode - The code of the store.
 * @param {string} startDate - The start date in RFC3339 format.
 * @param {string} endDate - The end date in RFC3339 format.
 * @return {Promise<Object>} - The response from the API containing the orders.
 * @throws {Error} - If the request fails.
 */
const getOrders = async (storeCode, startDate, endDate) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/statistic/getOrders`;

  try {
    const response = await api.post(endpoint, {
      storeCode,
      startDate,
      endDate,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching orders:', error);
    throw error;
  }
}

export default getOrders;
